import { FunctionComponent, PropsWithChildren, ReactElement } from "react";
import UserScanning from "../../components/UserScanning";

interface ProjectsPropsInterface {}
export const UserScan: FunctionComponent<
  PropsWithChildren<ProjectsPropsInterface>
> = (): ReactElement => {
  return <UserScanning />;
};
